import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import SectionHeading from "./SectionHeading";
import { trendSeries, trendStats } from "@/mocks/home";

export default function TrendPanel() {
  return (
    <section id="trend" className="w-full bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          badge="Heat Map"
          title="51cg5 实时热度 · 24 小时走势"
          desc="以小时为单位记录全网话题热度变化，快速判断当前热议焦点的升降节奏。"
          linkText="查看热度明细"
          linkHref="#trend"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="h-full rounded-lg border border-background-200/70 bg-background-50 p-4 md:p-6">
              <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
                <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">全网热度走势</h3>
                <span className="flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-700">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-radar-line"></i>
                  </span>
                  每 5 分钟刷新
                </span>
              </div>
              <div className="h-[260px] w-full md:h-[300px]">
                <ResponsiveContainer width="100%" height="100%">
                  <AreaChart data={trendSeries} margin={{ top: 8, right: 8, left: -18, bottom: 0 }}>
                    <defs>
                      <linearGradient id="heatFill" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="oklch(var(--accent-500))" stopOpacity={0.5} />
                        <stop offset="95%" stopColor="oklch(var(--accent-500))" stopOpacity={0.02} />
                      </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" stroke="oklch(var(--background-300))" vertical={false} />
                    <XAxis
                      dataKey="time"
                      tick={{ fontSize: 11, fill: "oklch(var(--foreground-500))" }}
                      axisLine={false}
                      tickLine={false}
                    />
                    <YAxis
                      tick={{ fontSize: 11, fill: "oklch(var(--foreground-500))" }}
                      axisLine={false}
                      tickLine={false}
                    />
                    <Tooltip
                      contentStyle={{
                        borderRadius: 8,
                        border: "1px solid oklch(var(--background-300))",
                        background: "oklch(var(--background-50))",
                        fontSize: 12,
                      }}
                      labelStyle={{ color: "oklch(var(--foreground-700))" }}
                      formatter={(value) => [`${value}万`, "热度"]}
                    />
                    <Area
                      type="monotone"
                      dataKey="value"
                      stroke="oklch(var(--accent-500))"
                      strokeWidth={2.5}
                      fill="url(#heatFill)"
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 lg:grid-cols-1">
            {trendStats.map((stat) => (
              <div
                key={stat.id}
                className="flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 p-4"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                  <i className={`${stat.icon} text-xl`}></i>
                </span>
                <div className="min-w-0">
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                  <div className="mt-0.5 font-heading text-lg font-black text-foreground-950 md:text-xl">
                    {stat.value}
                    <span className="ml-0.5 text-xs font-medium text-foreground-500">{stat.unit}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}